export enum ResidenceTypeEnum {
  OWN = 'OWN',
  RENT = 'RENT',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}
